/* Configuration Shopify (Storefront API) — clé publique, sûre à exposer côté client. */
const SHOPIFY_DOMAIN = 'ykwcqi-zu.myshopify.com';
const SHOPIFY_STOREFRONT_TOKEN = '8de9869cd424a246079eb0edc4187084';
const SHOPIFY_API_VERSION = '2026-07';
